// Funzione per normalizzare le immagini dei prodotti
export const getProductImage = (image) => {
  try {
    // Gestione dei casi null/undefined/stringa vuota
    if (!image || image === 'null' || image === 'undefined' || image === '') {
      return 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgdmlld0JveD0iMCAwIDIwMCAyMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9IjIwMCIgaGVpZ2h0PSIyMDAiIGZpbGw9IiNFRUVFRUUiLz48dGV4dCB4PSI1MCUiIHk9IjUwJSIgZG9taW5hbnQtYmFzZWxpbmU9Im1pZGRsZSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0iIzY2NiIgZm9udC1mYW1pbHk9IkFyaWFsIiBmb250LXNpemU9IjE0Ij5JbW1hZ2luZSBub24gZGlzcG9uaWJpbGU8L3RleHQ+PC9zdmc+';
    }

    // Se l'immagine è un oggetto JSON, lo convertiamo in stringa
    let imageUrl = image;
    if (typeof imageUrl === 'object') {
      // Gestione di più possibili proprietà dell'oggetto immagine
      imageUrl = imageUrl.text || imageUrl.hyperlink || imageUrl.value || imageUrl.url || 
                imageUrl.path || imageUrl.src || imageUrl.image || imageUrl.imageUrl || '';
    }

    // Assicurati che l'URL sia una stringa
    imageUrl = String(imageUrl || '').trim();

    // Se l'immagine è vuota dopo la conversione
    if (!imageUrl) {
      return 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgdmlld0JveD0iMCAwIDIwMCAyMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9IjIwMCIgaGVpZ2h0PSIyMDAiIGZpbGw9IiNFRUVFRUUiLz48dGV4dCB4PSI1MCUiIHk9IjUwJSIgZG9taW5hbnQtYmFzZWxpbmU9Im1pZGRsZSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0iIzY2NiIgZm9udC1mYW1pbHk9IkFyaWFsIiBmb250LXNpemU9IjE0Ij5JbW1hZ2luZSBub24gZGlzcG9uaWJpbGU8L3RleHQ+PC9zdmc+';
    }

    // Se ci sono più URL separati da ";", prendi solo il primo
    if (imageUrl.includes(';')) {
      imageUrl = imageUrl.split(';')[0].trim();
    }

    // Rimuovi eventuali spazi o caratteri non validi nell'URL
    imageUrl = imageUrl.replace(/\s+/g, '');

    // Gestione URL completi (case-insensitive)
    if (/^https?:\/\//i.test(imageUrl)) {
      return imageUrl;
    }
    
    // Gestione Base64
    if (imageUrl.startsWith('data:')) {
      return imageUrl;
    }

    // Gestione percorsi locali
    if (imageUrl.startsWith('/uploads')) {
      return typeof window !== 'undefined' ? `${window.location.origin}${imageUrl}` : imageUrl;
    }

    // Gestione percorsi relativi
    if (typeof window !== 'undefined') {
      return `${window.location.origin}/uploads/products/${imageUrl}`;
    }
    
    return imageUrl;
  } catch (err) {
    console.error('Errore nel caricamento dell\'immagine:', err);
    return 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgdmlld0JveD0iMCAwIDIwMCAyMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9IjIwMCIgaGVpZ2h0PSIyMDAiIGZpbGw9IiNFRUVFRUUiLz48dGV4dCB4PSI1MCUiIHk9IjUwJSIgZG9taW5hbnQtYmFzZWxpbmU9Im1pZGRsZSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0iIzY2NiIgZm9udC1mYW1pbHk9IkFyaWFsIiBmb250LXNpemU9IjE0Ij5JbW1hZ2luZSBub24gZGlzcG9uaWJpbGU8L3RleHQ+PC9zdmc+';
  }
};

// Funzione per gestire l'upload delle immagini
export const handleImageUpload = (file) => {
  return new Promise((resolve, reject) => {
    if (!file) {
      reject(new Error('Nessun file selezionato'));
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      resolve(reader.result);
    };
    reader.onerror = (error) => {
      reject(error);
    };
    reader.readAsDataURL(file);
  });
};

// Funzione per validare le dimensioni dell'immagine
export const validateImageSize = (file, maxSizeMB = 5) => {
  if (!file) return false;
  return file.size <= maxSizeMB * 1024 * 1024;
};

// Funzione per validare il tipo di immagine
export const validateImageType = (file) => {
  if (!file) return false;
  const validTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
  return validTypes.includes(file.type);
}; 